import defineMessages from "../../../../common/helpers/defineMessages";

const messages: {[prop: string]: { id: string }} = defineMessages({
    required: {
        id: "form.required",
    },
    usernameAlreadyUsed: {
        id: "account.username.alreadyUsed",
    },
    incorrectUsernameFormat: {
        id: "account.username.incorrectFormat",
    },
    incorrectEmailFormat: {
        id: "account.email.incorrectFormat",
    },
    emailAlreadyUsed: {
        id: "account.email.alreadyUsed",
    },
    shortFirstname: {
        id: "account.firstname.tooShort",
    },
    longFirstname: {
        id: "account.firstname.tooLong",
    },
    shortLastname: {
        id: "account.lastname.tooShort",
    },
    longLastname: {
        id: "account.lastname.tooLong",
    },
    unknownError: {
        id: "general.unknownError",
    },
    unrealBirthyear: {
        id: "account.birthyear.unreal",
    },
    unrealWorkSince: {
        id: "account.workSince.unreal",
    },
    passwordDoNotMatch: {
        id: "account.password.doNotMatch",
    },
    passwordTooShort: {
        id: "account.password.tooShort",
    },
    wrongOldPassword: {
        id: "account.password.wrongOld",
    },
    wrongPassword: {
        id: "account.password.wrong",
    },
    facebookConnectionError: {
        id: "facebook.connectionError.message",
    },
    googleConnectionError: {
        id: "google.connectionError.message",
    },
    tooShortPackName: {
        id: "package.name.tooShort",
    },
    tooLongPackName: {
        id: "package.name.tooLong",
    },
    packNameAlreadyExists: {
        id: "package.name.alreadyExists",
    },
    loginError: {
        id: "login.error",
    },
    tooManyAttempts: {
        id: "login.tooManyAttempts",
    },
    samePackName: {
        id: "package.name.same",
    },
    tooShortJoinName: {
        id: "join.name.tooShort",
    },
    tooShortPlanName: {
        id: "plan.name.tooShort",
    },
    tooLongPlanName: {
        id: "plan.name.tooLong",
    },
    incorrectJoinKey: {
        id: "join.key.incorrect",
    },
    incorrectSubscribeNameLength: {
        id: "subscribe.name.incorrectLength",
    },
    tooShortMessage: {
        id: "contact.tooShortMessage",
    },
    tooLongMessage: {
        id: "contact.tooLongMessage",
    },
    unsubscribeErrorP: {
        id: "unsubscribe.errorP",
    },
    tooLongComposerName: {
        id: "newComposer.name.tooLong",
    },
    unrealComposerLife: {
        id: "newComposer.life.unreal",
    },
    emailNotFound: {
        id: "recovery.emailNotFound",
    },
    mustBeLater: {
        id: "homework.mustBeLater",
    },
    noResult: {
        id: "homework.noResult",
    },
    tooLongClassName: {
        id: "className.tooLongClassName",
    },
    sameClassName: {
        id: "className.sameClassName",
    },
    classNameAlreadyExists: {
        id: "className.classNameAlreadyExists",
    },
    alreadyJoinToThisGroup: {
        id: "memory.groups.alreadyJoined",
    },
    groupNameAlreadyExists: {
        id: "memory.newGroup.groupNameAlreadyExists",
    },
    recordAlreadyExists: {
        id: "memory.groups.piece.alreadyExists",
    },
    noHomeworkOrExpired: {
        id: "homework.noHomeworkOrExpired",
    },
    bannedEmailProvider: {
        id: "signup.bannedEmailProvider",
    },
    mustBeOlder: {
        id: "homework.mustBeOlder",
    },
    unsupportedKamSolfaAudio: {
        id: "teachingSettings.unsupportedKamSolfaAudio"
    },
    maxLength: {
        id: "validation.token.maxLength"
    },
    positionAlreadyExists: {
        id: "choir.position.alreadyExists",
    },
    choirSocialMediaShortURL: {
        id: "choir.meta.additional.socialPages.error.shortURL",
    },
    choirSocialMediaUnknownURL: {
        id: "choir.meta.additional.socialPages.error.unknownURL",
    },
    choirSocialMediaAlreadyUsedURL: {
        id: "choir.meta.additional.socialPages.error.alreadyUsedURL",
    },
    choirPlaceNotFound: {
        id: "choir.meta.placeNotFound.validation"
    },
    choirPlaceInvalidCountry: {
        id: "choir.meta.place.invalidCountry"
    },
    choirPlaceShouldSelect: {
        id: "choir.meta.place.shouldSelectAnOption"
    },
    choirVideoAlreadyAdded: {
        id: "choir.meta.additional.videos.error.alreadyAddedURL"
    }
});

export default messages;
